import React from 'react';

interface IProps {
  tokens: any;
}

const useTokensTableData = ({ tokens }: IProps) => {
  // table memoized required fields
  const data = React.useMemo(() => tokens, [tokens]);
  const columns = React.useMemo(
    () => [
      {
        id: 'token',
        Header: 'Token',
        accessor: 'token',
        disableSortBy: true,
      },
      {
        id: 'quoteRate',
        Header: 'Price',
        accessor: 'quote_rate',
        disableSortBy: true,
      },
      {
        id: 'balance',
        Header: 'Amount',
        accessor: 'balance',
      },
      {
        id: 'volumeUSD',
        Header: 'Volume USD',
        accessor: 'balance',
      },
      {
        id: 'withdraw',
        Header: 'Actions',
        accessor: 'withdraw',
        disableSortBy: true,
        attach_right: true,
      },
    ],
    []
  );

  return { columns, data };
};

export { useTokensTableData };
